// treatment-selector.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-aus-declaration-execution-submission',
  templateUrl: './aus-declaration-execution-submission.component.html',
  styleUrls: []
})
export class AusDeclarationExecutionSubmissionComponent {
  @Input() noteFields: any[];
  @Input() newNote: any;
  @Input() yesLabel: string = 'Agree';
  @Input() noLabel: string = 'No';
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/common/aus-notes/ausDeclarationExecutionSubmission.component.ts